import React, { useState, useCallback, useEffect } from 'react'
import { Box, Grid } from '@mui/material'
import InfoCard from '../Components/InfoCard'
import YourWinsHighlights from './YourWinsHighlights'
import MyClasses from './MyClasses'
import ClassesOverview from './ClassesOverview'
import MyRecentMarkingActivity from './MyRecentMarkingActivity'
import useFetchData from '../../../../../../hooks/useFetchData'

const ForTeacher = ({ userId, isLoading, userData = {} }) => {
  const { isLoading: isLoadingActiveUl, data: activeUl } = useFetchData(
    `dashboard/teacher/${userId}/active-units-learning`
  )

  const { isLoading: isLoadingMyStudents, data: myStudents } = useFetchData(
    `dashboard/teacher/${userId}/my-students`
  )

  const { isLoading: isLoadingSkillsGrowth, data: skillsGrowth } = useFetchData(
    `dashboard/teacher/${userId}/skills-growth`
  )

  const { isLoading: isLoadingMyMarkings, data: myMarkings } = useFetchData(
    `dashboard/teacher/${userId}/my-markings`
  )
  const { isLoading: isLoadingMyClasses, data: myClasses } = useFetchData(
    `dashboard/teacher/${userId}/my-classes`
  )

  return (
    <Box>
      {/* MF-529 — minmax(0, 1fr): columns shrink instead of pushing the row past the viewport */}
      <Box className='grid gap-4 mb-4' sx={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
        <InfoCard
          title='Active Unit of learning '
          description='across all classes'
          value={activeUl || 0}
          bgColor='#fff'
          isLoading={isLoadingActiveUl}
        />
        <InfoCard
          title='SHOWING GROWTH'
          description='of my students'
          value={skillsGrowth?.showingGrowth || 0}
          bgColor='#fff'
          isLoading={isLoadingSkillsGrowth}
        />

        <InfoCard
          title='AVG TURNAROUND'
          description='marking speed'
          value={myMarkings?.markingFrequency || 0}
          bgColor='#fff'
          isLoading={isLoadingMyMarkings}
        />

        <InfoCard
          title='My Students'
          description='across all classes'
          value={myStudents || 0}
          bgColor='#fff'
          isLoading={isLoadingMyStudents}
        />
        <InfoCard
          title='Pending'
          description='skills to mark'
          value={skillsGrowth?.pendingSkillsToMark || 0}
          bgColor='#fff'
          isLoading={isLoadingSkillsGrowth}
        />

        <InfoCard
          title='My Markings'
          description='this period'
          value={myMarkings?.myMarkings || 0}
          bgColor='#fff'
          isLoading={isLoadingMyMarkings}
        />
      </Box>

      <Box className='flex flex-col gap-4 mb-4 relative'>
        <MyClasses userId={userId} isLoading={isLoadingMyClasses} myClasses={myClasses} />
        <ClassesOverview
          userId={userId}
          myClasses={myClasses || []}
          isLoadingMyClasses={isLoadingMyClasses}
        />
        <MyRecentMarkingActivity userId={userId} />
      </Box>
    </Box>
  )
}

export default ForTeacher
